module.exports = __webpack_public_path__ + "media/hyper/fonts/summernote-08c343ff91f188dfc1a7ae4ad1126b59.woff";